'use client';

import { useMemo } from 'react';
import { Marker as MapMarker } from 'react-map-gl/maplibre';
import { tv, VariantProps } from 'tailwind-variants';

const cluster = tv({
  variants: {
    variant: {
      'zmyle.primary': 'bg-zmyle-primary',
      'zmyle.secondary': 'bg-zmyle-secondary',
      'network.primary': 'bg-network-primary',
      'network.secondary': 'bg-network-secondary',
      'store.primary': 'bg-store-primary',
      'store.secondary': 'bg-store-secondary',
    },
  },
});

type ClusterVariants = VariantProps<typeof cluster>['variant'];

export type ClusterMarkerProps = {
  clusterId: string | number | undefined;
  latitude: number;
  longitude: number;
  pointCount: number;
  onClick({
    clusterId,
    lat,
    long,
  }: {
    clusterId: string | number | undefined;
    lat: number;
    long: number;
  }): void;
};

export function ClusterMarker({
  clusterId,
  latitude,
  longitude,
  pointCount,
  onClick,
}: ClusterMarkerProps) {
  const variant = useMemo(() => {
    const variants: ClusterVariants[] = [
      'zmyle.primary',
      'zmyle.secondary',
      'network.primary',
      'network.secondary',
      'store.primary',
      'store.secondary',
    ];

    const randomIndex = Math.floor(Math.random() * variants.length);

    return variants[randomIndex];
  }, []);

  function onClusterClick() {
    onClick({ clusterId, lat: latitude, long: longitude });
  }

  return (
    <MapMarker latitude={latitude} longitude={longitude}>
      <button
        className="relative cursor-pointer"
        type="button"
        onClick={onClusterClick}
      >
        <div
          className={cluster({
            className: 'h-10 w-10 rounded-full p-2 opacity-50 shadow-xl',
            variant,
          })}
        />

        <span
          className={cluster({
            className:
              'absolute top-1/2 left-1/2 h-8 w-8 -translate-1/2 rounded-full text-xl font-bold text-white',
            variant,
          })}
        >
          {pointCount}
        </span>
      </button>
    </MapMarker>
  );
}
